import { render, staticRenderFns } from "./constructionPersonnel.vue?vue&type=template&id=1437869c&scoped=true"
import script from "./constructionPersonnel.vue?vue&type=script&lang=js"
export * from "./constructionPersonnel.vue?vue&type=script&lang=js"
import style0 from "./constructionPersonnel.vue?vue&type=style&index=0&id=1437869c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1437869c",
  null
  
)

export default component.exports